<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <AuthorLeft></AuthorLeft>
                            </div>
                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>


                    </div>
                    <div :class="(webW?'col-sm-7':'col-sm-12')">
                        <div style="overflow-x: hidden;">

                            <AuthorTop v-if="!webW"></AuthorTop>

                            <!-- <el-switch
                                    v-if="webW"
                                    @click="openAutoReflashFunc"
                                    :style="'position: absolute;z-index: 1;right:10px;margin-top:10px;'"
                                    active-text="下拉刷新"
                                    v-model="openAutoReflash"
                                    active-color="#13ce66"
                                    inactive-color="#dddddd">
                            </el-switch> -->

                            <el-tabs id="zhutiMain" v-model="type"  @tab-click="tabClick" style="background-color: #fff;padding-left: 10px;">
                                <el-tab-pane  :label="(authorId==lander.uid?'我':'Ta')+'的回复'" name="comments"></el-tab-pane>
                            </el-tabs>
                            <div class="baiseback">
                                <div>
                                    <div class="baisebackblack" v-for="(t,i) in tableData" :timestamp="t.cts" placement="top" :key="i">
                                        <span class="margintop5"></span>
                                        <tr>
                                            <td valign="top" :class="webW?'pcutd2':'phoneutd2'" >
                                                <img :src="t.comentface"  :class="(webW?'pcavatarTop':'phoneavatarTop') + ' hander'" >
                                            </td>
                                            <td >                                        
                                               <p class="oneline seetiezi" >{{t.commentname+" "}}</p>
                                               <p><span class="typedesc">{{t.cts}}</span><span class="typedesc">        回复        </span>
                                               <span class="hander seetiezi" @click="goUHome(t.replyid)"> {{ t.replyname }}</span></p>                                           
                                            </td>
                                        </tr>
                                            <p  class="typedesc">
                                                
                                                <span class="pull-right hander" v-if="lander.uid==authorId" @click="deleteComment(t,i)" >
                                                        <i class="fa fa-trash"></i>删除评论</span>
                                                <p class="pinglunkuang">
                                                    <span v-html="t.cont"></span>
                                                </p>
                                            </p>                                                                         
                                        <div :class="webW?'grid-container2':'grid-container1'">
                                           
                                               <div  :class="webW?'pcutd2l':'phoneutd2l'">
                                                    <img class="fplfaceimgX hander" :src="t.authorface">
                                               </div>
                                               <div>
                                                    <p class="typedesc">{{t.authorname+" "}}</p>
                                                    <div class="hander seetiezi" @click="seeForum(t,i)">{{t.ftitle}}</div>
                                              </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="baiseback"  v-if="tableDataloading">
                                    <div class="center">
                                        <img src="../../../assets/img/loading.gif">
                                        <p class="typedesc">数据加载中....</p>
                                    </div>
                                </div>
                                <div class="baiseback" style="height: 100vh;"  v-if="!tableDataloading&&tableData.length==0">
                                    <div class="center">
                                        <img src="../../../assets/img/zwsj.png">
                                        <p class="typedesc">暂无数据</p>
                                    </div>
                                </div>


                                <div class="center" >
                                    <el-pagination 
                                            @current-change="handlePageChange"
                                            :current-page="query.pageNo"
                                            :page-size="query.pageSize"
                                            layout="prev, pager, next, jumper"
                                            :total="pageTotal">
                                    </el-pagination>


                                </div>

                                <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>
                            </div>
                            <div class="baiseback">
                                <Footer></Footer>
                            </div>
                        </div>
                    </div>

                      <div class="col-sm-3" v-if="webW">
                        <div id="JfRightMenuOut">
                            <div :class="(fixedRightmenu?'fixedMenuRT':'')" :style="fixedRightmenu?('width:'+RightMenuWidth+'px'):''" id="JfRightMenu">
                                 <AuthorTop></AuthorTop>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h200"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotopBot">
    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {getAuthotrCommentPage, delAttFansById, delComment,getAuthorInfo} from '../../../api';
    import  PubSub from 'pubsub-js'

    import Footer from "../Footer";
    import AuthorTop from "./AuthorTop";
    import AuthorLeft from "./AuthorLeft";

    export default {
        name: 'Fans',
        components: {
            Footer,
            AuthorTop,
            AuthorLeft

        },

        data() {
            return {
                webW:true,
                scrolltop: false,
                nouse: false,//禁用
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,
                fixedRightmenu: false,
                RightMenuWidth: 0,
                openAutoReflash:false,
                scrolltop:false,
                nouse:false,//禁用
                lander: {},
                authorId:'',
                // 信息
                tableData: [],
                tableDataloading:true,
                tableDataFinish:false,//避免滚动条在最后一直请求

                query: {
                    tyepId: '',
                    pageNo: 1,
                    pageSize:30,
                },
                pageTotal: 0,



            };
        },
        methods: {
            seeForum(t,i){
                this.$router.push("ForumDetail?id="+t.forumId);
            },
            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },

            tabClick(tab, event) {

               this.query.pageNo=1;
               this.tableData=[];
                this.tableDataFinish=false;
               this.getAuthotrCommentPage();
            },


            openAutoReflashFunc(){
                if(this.openAutoReflash)this.tableDataFinish=false;
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData=[];
                this.getAuthotrCommentPage();

                this.tableDataFinish=false;

                let forumMain=document.getElementById('zhutiMain');
                let top=forumMain.offsetTop;
                document.documentElement.scrollTop=top;
                 document.body.scrollTop=top;

            },



            //获取帖子分页
            getAuthotrCommentPage() {
                this.tableDataloading=true;
                this.tableDataFinish=false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.commentUid=this.authorId;



                getAuthotrCommentPage( this.query).then((res) => {
                    this.tableDataloading=false;
                    dealResult(res.data);


                    if (res.data.status == 1) {


                        let li= res.data.obj.list;
                        
                        if(li.length==0){

                            this.tableDataFinish=true;

                            return ;
                        }



                        this.tableData=this.tableData.concat(li);
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if( this.openAutoReflash  ) {
                            if( res.data.obj.hasNextPage )this.query.pageNo=res.data.obj.nextPage;
                            else this.query.pageNo=this.query.pageNo+1;
                        }

                        this.fixedmenu();


                    }else {
                        this.tableDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
             goUHome(uid) {
                this.$router.push('Home?type=myforum&authorId=' + uid);
            },


            fixedmenu(){

                let JfLeftMenu = document.getElementById('JfLeftMenu');
                let JfRightMenu = document.getElementById('JfRightMenu');

                let that=this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight  ;
                    let wh = document.documentElement.clientHeight  ;




                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;
                        that.RightMenuWidth = JfRightMenu.offsetWidth;

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = true;
                        }
                        let rightHeight = JfRightMenu.offsetHeight;
                        let rightTop = JfRightMenu.offsetTop;
                        if (t > rightTop + rightHeight + 50) {
                            that.fixedRightmenu = true;
                        } else {
                            that.fixedRightmenu = true;
                        }


                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;


                    //滚动条到底部加载数据
                    if(t+wh>=h-100 && that.openAutoReflash && !that.tableDataFinish){

                        if(!that.tableDataloading)that.getAuthotrCommentPage();
                    }



                }

            },
            deleteComment(t, index ) {
                if(this.lander.uid!=this.authorId)return;
                    this.$confirm("确定删除 ？ ", "提示", {
                        type: "warning",
                    }) .then(() => {
                        this.loading = this.$loading({
                            lock: true,
                            text: "请求中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        let o={ id:t.id,uid:this.lander.uid,token:this.lander.token}
                        delComment(o).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg);
                                this.tableData.splice(index, 1);

                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                    });
            },

        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            this.lander = JSON.parse(this.$store.state.logininfo);


            //固定左右菜单
            this.fixedmenu();
            if(this.$route.query.authorId!=undefined){
                this.authorId = this.$route.query.authorId;

                this.query.pageNo=1;
                this.tableData=[];
                this.getAuthotrCommentPage()

            }



        } , watch:{
            $route:function(value){
                if(this.$route.query.authorId!=undefined&&(this.$route.query.type=="comments")){
                    if(this.$route.query.authorId!= this.authorId){

                        this.authorId = this.$route.query.authorId;

                        this.query.pageNo=1;
                        this.tableData=[];
                        this.getAuthotrCommentPage()
                    }


                }
                this.fixedmenu();

            }
        },
        activated() {
            //固定左右菜单
            this.fixedmenu();
        },
        deactivated() {

        }

    };
</script>
<style scoped>
.grid-container1 {
  display: grid;
  grid-template-columns: 12% auto; /* 定义两列 */
  gap: 10px; /* 控制列间距 */
  background: #f9f9f9;
}
.grid-container2 {
  display: grid;
  grid-template-columns: 7% auto; /* 定义两列 */
  gap: 10px; /* 控制列间距 */
  background: #f9f9f9;
}

</style>
